"use client";

import type { ScenarioCatalogue } from "@/lib/presenter/types";

/**
 * Presenter-chrome subcomponent: the "Scenarios" play menu.
 * One button per scenario in the catalogue, ordered by SCENARIO_ORDER.
 */
const SCENARIO_ORDER = [
  "t1-onboarding",
  "t2-bank-financed",
  "t3-reverse-corridor",
  "t4-air-cargo",
  "final-reveal",
  "replay-variant",
];

export function ScenarioPlayMenu({
  catalogue,
  manualMode,
  onPlay,
}: {
  catalogue: ScenarioCatalogue;
  manualMode: boolean;
  onPlay: (scenarioId: string, manualMode: boolean) => void;
}) {
  const scenarioIds = Object.keys(catalogue).sort((a, b) => {
    const ai = SCENARIO_ORDER.indexOf(a);
    const bi = SCENARIO_ORDER.indexOf(b);
    if (ai === -1 && bi === -1) return a.localeCompare(b);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
  return (
    <>
      <p className="mt-3 text-orbitra-teal-soft uppercase tracking-[0.18em]">Scenarios</p>
      <ul className="mt-1 flex flex-col gap-1">
        {scenarioIds.map((id) => (
          <li key={id}>
            <button
              onClick={() => onPlay(id, manualMode)}
              className="w-full rounded border border-state-verified/20 bg-orbitra-ink/40 px-2 py-1 text-start text-orbitra-paper hover:border-state-verified/60 hover:bg-state-verified/10"
            >
              ▶ {catalogue[id]?.label ?? id}
            </button>
          </li>
        ))}
      </ul>
    </>
  );
}
